/* eslint-disable spaced-comment,func-names,object-shorthand */
import React from 'react';
import request from 'superagent';
import Highcharts from 'highcharts';
import Chart from "../Chart";
import API from '../../../config/API';
import {getDataFilesCacheVersion} from "../../../helpers/cache";

require('highcharts-more')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data.src')(Highcharts);
const ReactHighcharts = require('react-highcharts').withHighcharts(Highcharts);

class HGTurnover extends Chart {

    componentDidMount() {
        request.get(API.getHost('data').concat(getDataFilesCacheVersion('/data-feeds/charts/MarketInsights/rolling_turnover_hg_usa.csv'))).then(data => {

            const options = {
                //set chart type
                chart: {
                    type: 'spline',
                    //set chart to its container
                    renderTo: 'turnover_hg_usa_container',
                    height: 600,
                    style: {
                        fontFamily: 'Exo'
                    }
                },
                //set title
                title: {
                    text: 'TRACE High Grade Turnover (Trailing 12 Months)',
                    style: {
                        color: '#4D759E'
                    },
                    align: 'center'
                },
                //set x-axis
                xAxis: {
                    title: {
                        text: 'Date',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    gridLineWidth: 1,
                    //need datetime to display dates on x-axis
                    type: 'datetime'
                },
                //set y-axis
                yAxis: {
                    title: {
                        text: 'TRACE High Grade Turnover (Trailing 12 Months) ( % )',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    //make y-axis labels percents
                    labels: {
                        formatter: function () {
                            return `${this.value}%`;
                        }
                    }
                },
                //set tooltip
                tooltip: {
                    valueSuffix: '%',
                    valueDecimals: 2,
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>'
                },
                //set legend
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    borderWidth: 1,
                    borderRadius: 5
                },
                //instantiate series
                series: [],
                //define series color scheme
                colors: [
                    '#1D5B7F',
                    '#76b34d',
                    '#636569',
                    '#6786B8',
                    '#8244FF',
                    '#848486',
                    '#a42a47',
                    '#f8dc32',
                    '#2a84b9',
                    '#91c271',
                    '#818388',
                    '#8598c6',
                    '#cd3d60',
                    '#f6e35b',
                    '#11374c',
                    '#476c2e',
                    '#3b3d3f',
                    '#374f75',
                    '#621903',
                    '#ad9506'
                ],
                //set general plot options
                plotOptions: {
                    spline: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                //set name of chart downloads
                exporting: {
                    filename: 'MarketAxess_rolling_turnover_hg_usa',
                    //enable download icon
                    enabled: true,
                    //add image to download
                    chartOptions: {
                        chart: {
                            events: {
                                load: function () {
                                    this.renderer.image('/public/images/charts/marketaxess_logo2.gif', 90, 75, 300, 48).attr({
                                        opacity: 0.1
                                    }).add();
                                }
                            }
                        }
                    }
                },
                //disable credits
                credits: {
                    enabled: false
                }
            };

            //names of labels in order of series. make sure they are the same as series header in data file
            const names = ['All', 'Top 1000 CUSIPs by Volume', 'Ex-Top 1000 CUSIPs'];
            //get csv file, multiply by 100 (divide by .01) and populate chart
            this.readCSV(options, data.text, 0.01, names);

            this.setState({options});
        });
    }

    render() {
        if (!this.state.options) return null;

        return(
            <div className="container">
                <ReactHighcharts config={this.state.options}/>
            </div>
        );
    }
}

export default HGTurnover;



// WEBPACK FOOTER //
// ./frontend/components/Charts/MarketInsights/HGTurnover.jsx